import { useMemo } from 'react';

import { ReceiptIcon } from 'lucide-react';

import { FormField } from '@/_components';
import { Address } from '@/_containers';
import type { AddressQuerySchema, AddressTypeSchema } from '@/_containers/inputs/address/shared';
import { showFormField } from '@/_shared';

import type { AddressSectionProps } from './types';

import { useCompanyFormContext } from '../../form-context';

export function AddressSection({ isEdit, onRequestEdit }: AddressSectionProps) {
  const form = useCompanyFormContext();

  const [addresses] = form.watch(['addresses']);

  const addressMap = useMemo(() => {
    const map = new Map<AddressTypeSchema, AddressQuerySchema>();
    addresses?.forEach((address) => {
      map.set(address.type || 'physical', address);
    });
    return { contact: map.get('physical'), billing: map.get('mailing') };
  }, [addresses]);

  return (
    <>
      {showFormField(isEdit, addressMap.contact) && (
        <FormField
          control={form.control}
          name="addresses"
          render={({ field }) => (
            <Address
              type="contact"
              text="Contact Address"
              value={addressMap.contact}
              isEdit={isEdit}
              onChange={field.onChange}
              onRequestEdit={onRequestEdit}
            />
          )}
        />
      )}
      {showFormField(isEdit, addressMap.billing) && (
        <FormField
          control={form.control}
          name="addresses"
          render={({ field }) => (
            <Address
              type="billing"
              text="Billing Address"
              icon={ReceiptIcon}
              value={addressMap.billing}
              isEdit={isEdit}
              onChange={field.onChange}
              onRequestEdit={onRequestEdit}
            />
          )}
        />
      )}
    </>
  );
}
